"use client";

import { FC, PropsWithChildren } from "react";

import { Drawer, Modal, Toast } from "@/shared/ui";

import { GoogleAuthProvider } from "./google-auth.provider";
import { PosthogProvider } from "./posthog.provider";
import { ReactQueryProvider } from "./react-query.provider";

export const AppProviders: FC<PropsWithChildren> = ({ children }) => {
  return (
    <GoogleAuthProvider>
      <PosthogProvider>
        <ReactQueryProvider>
          {children}

          {/* UI Store components */}
          <>
            <Modal />
            <Toast />
            <Drawer />
          </>
        </ReactQueryProvider>
      </PosthogProvider>
    </GoogleAuthProvider>
  );
};
